import { ONE_MINUTE_MS } from '~/shared/constants/time'
import { zeroizeSeconds } from '~/shared/helpers/date'
import {
  DEFAULT_DURATION_MS,
  DEFAULT_SCALE_MS,
  type EpgTimeLine,
} from './index.h'

/**
 * Calculate timeline start time from timestamp (or current)
 * Timeline can start only on scale division points (e.g. for scale 30 minutes - 9:00, 9:30, 10:00, 10:30, etc.)
 */
export const getTimelineStart = (
  to?: number | null,
  scaleMs = DEFAULT_SCALE_MS
): number => {
  const date = to ? new Date(to) : new Date()
  const scale = Math.trunc(scaleMs / ONE_MINUTE_MS)
  date.setMinutes(date.getMinutes() < scale ? 0 : scale)
  return zeroizeSeconds(date)
}

/**
 * Create new `EpgTimeLine` object
 */
export const createNewTimeline = (from?: number): EpgTimeLine => {
  return {
    scale: DEFAULT_SCALE_MS,
    duration: DEFAULT_DURATION_MS,
    firstDayStamp: getTimelineStart(from),
  }
}

/**
 * Update existing `EpgTimeLine` object with new values
 */
export const updateExistingTimeline = (
  current: EpgTimeLine,
  to: Partial<EpgTimeLine>
): EpgTimeLine => {
  const scale = to.scale ?? current.scale
  const duration = to.duration ?? current.duration
  const firstDayStamp = getTimelineStart(null, scale)
  return { scale, duration, firstDayStamp }
}
